import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartAppBannerComponent } from '@app/core/smart-app-banner/smart-app-banner.component';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { reducers } from '@app/core/i18n/store/reducers';
import { RefModule } from '@app/shared/components/ref/ref.module';
import { SvgModule } from '@app/shared/components/svg/svg.module';

@NgModule({
  imports: [CommonModule, RouterModule, StoreModule.forFeature('i18n', reducers), RefModule, SvgModule],
  declarations: [SmartAppBannerComponent],
  exports: [SmartAppBannerComponent]
})
export class SmartAppBannerModule {}
